<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" md="4">
        <card :loading="loading" :disabled="loading">
          <v-form ref="form" @submit.prevent="updateProfile()">
            <validation-observer ref="validator" v-slot="{ dirty }">
              <card-content class="py-4">
                <edit-form
                  v-model="profile"
                  :readonly="readonly"
                  @changePasswordDialog="changePasswordFialog = true"
                />
              </card-content>
              <card-actions v-if="$canEdit()">
                <v-btn
                  id="form-btn-save"
                  color="primary"
                  type="submit"
                  :disabled="!dirty"
                  :loading="loading"
                  depressed
                >
                  Сохранить
                </v-btn>
              </card-actions>
            </validation-observer>
          </v-form>
        </card>
      </v-col>
    </v-row>

    <change-password-dialog v-model="changePasswordFialog" />
  </v-container>
</template>

<script>
import Repository from "@/api/profile";
import NotificationMixin from "@/mixins/NotificationMixin";
import CheckPermissionMixin from "@/mixins/CheckPermissionMixin";
import EditForm from "./EditForm.vue";
import ChangePasswordDialog from "./ChangePasswordDialog.vue";

export default {
  components: {
    EditForm,
    ChangePasswordDialog
  },

  mixins: [NotificationMixin, CheckPermissionMixin],

  data() {
    return {
      changePasswordFialog: false,
      profile: {},
      loading: false,
      loadingHistory: false,
      items: [],
      options: {},
      count: 0
    };
  },

  computed: {
    readonly() {
      return !this.$canEdit();
    }
  },

  async mounted() {
    this.loadProfile();
  },

  methods: {
    async updateProfile() {
      if (!(await this.$refs.validator.validate())) return false;

      this.loading = true;

      try {
        let data = {
          name: this.profile.name
        };

        let response = await Repository.setProfile(data);
        await this.$store.dispatch("fetchProfile");
        this.sendAlert(response.data.alert);

        this.$refs.validator.reset();
      } catch (error) {
        return true;
      } finally {
        this.loading = false;
      }
    },

    async loadProfile() {
      try {
        this.loading = true;
        const { data } = await Repository.getProfile();
        this.profile = data;
      } catch (error) {
        return true;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
